/** Asks the page's highlight hook to pulse an element by id. */
export const SETTINGS_ANCHOR_EVENT = "settings:anchor-highlight";

/** Query param for targets a "#" jump would misplace. */
export const HIGHLIGHT_PARAM = "highlight";

/** The id a route asks to pulse: its ?highlight= if it has one, else its #anchor. */
export function highlightTarget(route: string): string | null {
  const [beforeHash, hash] = route.split("#");
  const query = beforeHash.split("?")[1] ?? "";
  return new URLSearchParams(query).get(HIGHLIGHT_PARAM) ?? decodeHash(hash);
}

function decodeHash(hash: string | undefined): string | null {
  if (!hash) return null;
  try {
    return decodeURIComponent(hash);
  } catch {
    return hash;
  }
}

/** Next router same-page navigation fires no hashchange, so dispatch our own. */
export function requestAnchorHighlight(route: string) {
  const target = highlightTarget(route);
  if (!target) return;
  if (!window.location.pathname.endsWith(route.split(/[?#]/)[0])) return;
  window.dispatchEvent(
    new CustomEvent(SETTINGS_ANCHOR_EVENT, { detail: target }),
  );
}
